import { BoxProps, Card } from "@chakra-ui/react";

interface CustomCardProps extends BoxProps {
  children: React.ReactNode;
}

const CustomCard = ({ children, ...props }: CustomCardProps) => {
  return (
    <Card
      boxShadow="
        0px 1px 2px 0px #1018280D, 
        inset 0px -2px 0px 0px #1018280D, 
        inset 0px 0px 0px 1px #1018282E
      "
      {...props}
    >
      {children}
    </Card>
  );
};

export default CustomCard;
